export const enum SnPublicity {
  Private = 'private',
  Public = 'public',
}
